import { graphql } from '../../gql'

export const UPDATE_SUBSCRIPTION_PLAN = graphql(/* GraphQL */ `
  mutation updatePlan(
    $organizationId: String
    $plan: OBPlanId
    $interval: BillingInterval
    $attribution: AttributionInput
    $quantity: Int
  ) {
    billingUpdateSubscriptionPlan(
      organizationId: $organizationId
      plan: $plan
      interval: $interval
      quantity: $quantity
      attribution: $attribution
    ) {
      ... on BillingUpdateSubscriptionPlanResponse {
        success
        scheduledUpdate {
          newPlan
          newInterval
          newQuantity
          effectiveDate
        }
      }
      ... on BillingError {
        userFriendlyMessage
      }
    }
  }
`)

export const START_TRIAL = graphql(/* GraphQL */ `
  mutation StartTrial($input: StartTrialInput!) {
    startTrial(input: $input) {
      __typename
      ... on VoidMutationError {
        message
      }
    }
  }
`)

export const GET_PREVIEW_INVOICE = graphql(/* GraphQL */ `
  query GetPreviewInvoice(
    $organizationId: OrganizationId!
    $plan: OBPlanId!
    $interval: BillingInterval!
    $quantity: Int!
  ) {
    getPreviewInvoice(
      input: {
        organizationId: $organizationId
        plan: $plan
        interval: $interval
        quantity: $quantity
      }
    ) {
      ... on GetPreviewInvoiceResponse {
        chargeAmount
        creditAmount
        isScheduledChange
        nextBillingDate
      }
      ... on VoidMutationError {
        message
      }
    }
  }
`)
